export const apiConfig = {
    distributer_token_list : 'api/distributor_tokens/list',
    company_info_search : 'api/company_info/search',
    assign_to_installer : 'api/distributor_tokens/assign_to_installer',
    purchase_token_cart : 'api/purchase_tokens/carts_url',
    assign_to_distributor : 'api/distributor_tokens/assign_to_distributor',
  
  }